import { RootState } from 'editor/src/store/index';

const getIsProductResizable = (state: RootState): boolean => !!state.design.designData?.dimensions;

export default getIsProductResizable;
